module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_ccaas-small-86a47da4598c958637bbb23e2cf03c04.png";